/**
 * @fileoverview Agent definition for style-guardrails-generator-v2.
 *
 * This agent analyzes writing samples and influences to generate
 * guardrails for style guides: tone keywords, recommended phrases,
 * anti-influences, and custom banned phrases.
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'style-guardrails-generator-v2',
  kind: 'primitive',
  name: 'Style Guardrails Generator',
  description: 'Analyzes writing samples and influences to generate tone keywords, recommended phrases, anti-influences, and banned phrases for style guides.',
  category: 'style',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2025-01',
    lastUpdated: '2025-01',
    usedBy: [
      'StyleGuideComposer',
      'use-style-guardrails-generator-v2.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'style-analyzer-v2',
      'generate-custom-style-guide-v2',
    ],
    taxonomyPath: 'meta.style.generation',
  },
};
